import React, { useEffect, useState } from 'react';
import Fuse from 'fuse.js';
import { Container, ClearButton, SearchInput, SearchIcon, SearchContainer, MovieList, LoadMoreButton } from './styles.js'; // Adicionei o LoadMoreButton
import MovieType2 from '../../components/movie/type-2.js';

import { FaTimes } from 'react-icons/fa';
import Load from '../../components/load/index.js';

const MovieSearchPage = ({ movies, setBackgroundNav }) => {

  const [date, setDate] = useState(null);

  const [query, setQuery] = useState(''); // Query de pesquisa
  const [filteredMovies, setFilteredMovies] = useState([]); // Filmes filtrados
  const [visibleMovies, setVisibleMovies] = useState(20); // Quantidade de filmes visíveis (inicialmente 20)

  useEffect(() => {
    window.scrollTo(0, 0);
    setDate(new Date());
  }, []);

  useEffect(() => {
    // Garante que 'movies' está definido antes de tentar acessá-lo
    if (movies && movies.movies) {
      // Caso haja uma pesquisa ativa, resetamos a quantidade de filmes visíveis para 20
      if (query) {
        const results = fuse.search(query);
        setFilteredMovies(results?.map(result => result.item).slice(0, visibleMovies)); // Carrega os primeiros 20 filmes filtrados
      } else {
        setFilteredMovies(movies.movies.slice(0, visibleMovies)); // Caso não haja busca, exibe os filmes iniciais
      }
    } else {
      setFilteredMovies([]); // Define como lista vazia por segurança
    }
  }, [movies, visibleMovies, query]); // Dependência de 'query' e 'visibleMovies' para ajustar a lista

  // Configuração do Fuse.js (usa um array vazio se 'movies' for nulo)
  const fuse = new Fuse(movies?.movies || [], {
    keys: ['name'], // Filtra pela propriedade "name"
    threshold: 0.3, // Ajusta a precisão da busca
  });

  // Função para atualizar a lista de filmes filtrados conforme o usuário digita
  const handleSearch = (e) => {
    const searchQuery = e.target.value;
    setQuery(searchQuery);
    // Sempre que a pesquisa mudar, reseta a quantidade de filmes visíveis para 20
    setVisibleMovies(20);
    if (searchQuery) {
      const results = fuse.search(searchQuery);
      setFilteredMovies(results?.map(result => result.item).slice(0, 20)); // Carrega os primeiros 20 filmes da pesquisa
    } else {
      setFilteredMovies(movies?.movies.slice(0, 20) || []); // Caso a pesquisa seja limpa, exibe os primeiros 20 filmes
    }
  };

  const clearSearch = () => {
    setQuery('');
    setVisibleMovies(20); // Resetando para os primeiros 20 filmes
    setFilteredMovies(movies?.movies.slice(0, 20) || []); // Reseta ao estado inicial
  };

  const handleLoadMore = () => {
    const newVisibleMovies = visibleMovies + 20;
    setVisibleMovies(newVisibleMovies); // Aumenta o número de filmes visíveis

    if (query) {
      const results = fuse.search(query);
      setFilteredMovies(results?.map(result => result.item).slice(0, newVisibleMovies)); // Carrega mais filmes filtrados pela pesquisa
    } else {
      setFilteredMovies(movies?.movies.slice(0, newVisibleMovies) || []); // Caso não haja pesquisa, carrega mais filmes normalmente
    }
  };

  // Verifica se há mais filmes para exibir
  const hasMoreMovies = filteredMovies.length < (query ? fuse.search(query).length : movies?.movies.length);

    useEffect(() => {
      document.querySelector('meta[name="theme-color"]').setAttribute('content', "#202020")
      document.title = 'Pesquisar - Moov Pro';
      setBackgroundNav("#202020")
    }, []);

  return (
    <Container>
      <SearchContainer>
        <SearchInput
          type="text"
          placeholder="Pesquise por filmes, séries e animes..."
          value={query}
          onChange={handleSearch}
        />
        <SearchIcon />
        {query && (
          <ClearButton onClick={clearSearch}>
            <FaTimes />
          </ClearButton>
        )}
      </SearchContainer>
      <MovieList>
        {filteredMovies?.map((movie, index) => (
          <MovieType2 movie={movie} date={date} key={index} />
        ))}
      </MovieList>
      {!movies?.movies && <Load align_center={true} />}
      {hasMoreMovies && (
        <LoadMoreButton onClick={handleLoadMore}>Ver mais</LoadMoreButton>
      )}
    </Container>
  );
};

export default MovieSearchPage;
